import { AuditLogsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { auditLogsKeys } from 'app/queries/auditLogs/auditLogsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof auditLogsKeys.entityTypes>>;

export const createFetchAuditLogEntityTypesQueryFn =
  (call: TCall) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(AuditLogsService.adminListAuditLogEntityTypes(), signal));
